import React from "react";
import Gallery from "../../components/Gallery/Gallery";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import ScrollButton from "../../components/ScrollButton/ScrollButton";

const ModaPage = () => {
  return (
    <>
      <NavBar></NavBar>
      <Gallery></Gallery>
      <ScrollButton></ScrollButton>
      <Footer></Footer>
    </>
  );
};

export default ModaPage;
